var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.getSideDrawer ? 'side-drawer' : 'side-drawer-collapsed'
  }, [_c('div', {
    staticClass: "menu-area"
  }, [_c('div', {
    staticClass: "menus"
  }, [_c('List', {
    attrs: {
      "to": "/dashboard",
      "label": _vm.$t('adminNav.dashboard'),
      "icon": "dashboard",
      "id": "dashboard-nav"
    }
  }), _vm.user.role === 'admin' ? _c('List', {
    attrs: {
      "to": "/customers",
      "label": "Customers",
      "icon": "users",
      "id": "customer-nav"
    }
  }) : _c('List', {
    attrs: {
      "to": "/customers/".concat(_vm.user.uid),
      "label": "Customers",
      "icon": "users",
      "id": "customer-nav"
    }
  }), _vm.user.role === 'admin' ? _c('List', {
    attrs: {
      "to": "/users",
      "label": "Users",
      "icon": "users",
      "id": "users-nav"
    }
  }) : _vm._e(), _vm.user.role === 'admin' ? _c('List', {
    attrs: {
      "to": "/vehicles",
      "label": "Vehicles",
      "icon": "car",
      "id": "users-nav"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "logout-button",
    attrs: {
      "id": "logout-user"
    },
    on: {
      "click": _vm.logoutUser
    }
  }, [_vm.getSideDrawer ? _c('span', [_vm._v(_vm._s(_vm.$t("adminNav.logout")))]) : _vm._e(), _vm._v("\n          "), _c('i', {
    staticClass: "fa fa-sign-out"
  })]), _c('div', {
    staticClass: "text-left mt-3 text-muted"
  }, [_c('small', {
    staticClass: "ml-1 text-center"
  }, [_vm._v(_vm._s(_vm.$t("adminNav.version")) + " " + _vm._s(_vm.versionCode))])])])]), _c('button', {
    class: _vm.getSideDrawer ? 'toggle-sidebar' : 'toggle-sidebar-rotated',
    on: {
      "click": _vm.toggleDrawer
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }